export const metricStore = {};